import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const clickNewSignature = {
  element: '#add-signature',
  popover: {
    title: $format('label.TOURS.STUDIO.CREATE.CLICKING_NEW_SIG.TITLE'),
    description: $format('label.TOURS.STUDIO.CREATE.CLICKING_NEW_SIG.DESCRIPTION'),
    side: 'left',
    align: 'start',
    onNextClick: () => {
      const addButtonElement = document.querySelector('#add-signature');

      if (addButtonElement) {
        addButtonElement.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      }
    }
  }
};
